import { logAmplitudeEvent } from 'amplitude/amplitude'
import { ELECTRICAL_AUTO_ADDED_AUTHOR } from 'elements/electrical/constants'
import { StudioComponentItem } from 'types/global'

function getOtherAuthoredBy(other: { authored_by?: string; userData?: { authored_by?: string } }): string | undefined {
  return other.authored_by ?? other.userData?.authored_by
}

export const updateSystemHardware = (
  componentType: string,
  componentActivationId: number,
  targetUuids: string[],
  params?: Record<string, any>
): StudioComponentItem[] => {
  if (componentType === 'module') {
    return targetUuids.map((targetUuid) => {
      // Object can either my an OsSystem or OsModuleGrid since this function invokes a lookup on the OsDesignerScene
      const obj = window.editor.objectByUuid(targetUuid)
      window.editor.execute(
        new window.UpdateElectricalsCommand(obj, 'setModuleTypeByModuleId', componentActivationId, obj.moduleId)
      )
      return obj
    })
  } else if (componentType === 'inverter') {
    var inverterType = window.AccountHelper.getInverterById(componentActivationId)
    return targetUuids.map((targetUuid) => {
      var inverter = window.editor.objectByUuid(targetUuid)
      if (!inverter) {
        window.editor.execute(
          new window.AddObjectCommand(
            new OsInverter({ inverter_id: componentActivationId }),
            window.editor.selectedSystem,
            false
          )
        )
      } else if (inverterType) {
        const oldInverterType = inverter.getComponentData()
        window.editor.execute(
          new window.UpdateElectricalsCommand(inverter, 'componentType', inverterType, oldInverterType)
        )
      } else {
        console.error('Error selecting component')
      }
      return inverter
    })
  } else if (componentType === 'battery') {
    var batteryType = window.AccountHelper.getBatteryById(componentActivationId)

    // Track battery selection
    logAmplitudeEvent('battery_selected', {
      batteryCode: batteryType?.code || componentActivationId,
      batteryManufacturer: batteryType?.manufacturer,
      systemId: window.editor.selectedSystem.uuid,
      targetUuids: targetUuids,
      isReplacement: targetUuids.length > 0,
    })

    return targetUuids.map((targetUuid) => {
      var battery = window.editor.objectByUuid(targetUuid)

      if (!battery) {
        window.editor.execute(
          new window.AddObjectCommand(
            new OsBattery({ battery_id: componentActivationId }),
            window.editor.selectedSystem,
            false
          )
        )
      } else if (batteryType) {
        const oldBatteryType = battery.getComponentData()
        window.editor.execute(
          new window.UpdateElectricalsCommand(battery, 'componentType', batteryType, oldBatteryType)
        )
      } else {
        console.error('Error selecting component')
      }
      return battery
    })
  } else if (componentType === 'other') {
    var otherType = window.AccountHelper.getOtherById(componentActivationId)
    if (otherType?.other_component_type === 'dc_optimizer') {
      const selectedSystem = window.editor.selectedSystem
      // [] means create the optimiser but apply to no module grids yet (e.g. "some panels" picker).
      // undefined as second arg would apply to every grid on the system — do not use [] for that.
      const moduleGridUuids = targetUuids.length ? targetUuids : []
      return [selectedSystem.addDcOptimizer(componentActivationId, moduleGridUuids, !!params?.autoAdded)]
    } else {
      if (!targetUuids?.length) {
        let addedObject = new window.OsOther({ other_id: componentActivationId, ...(params || {}) })
        window.editor.execute(new window.AddObjectCommand(addedObject, window.editor.selectedSystem, false))
        return [addedObject]
      } else {
        return targetUuids.map((targetUuid) => {
          var other = window.editor.objectByUuid(targetUuid)
          if (otherType) {
            const oldOtherType = other.getComponentData()
            const swapAuthoredBy = params?.authored_by
            const nextOtherType =
              swapAuthoredBy && getOtherAuthoredBy(other) === ELECTRICAL_AUTO_ADDED_AUTHOR
                ? { ...otherType, authored_by: swapAuthoredBy }
                : otherType
            window.editor.execute(
              new window.UpdateElectricalsCommand(other, 'componentType', nextOtherType, oldOtherType)
            )
          }
          return other
        })
      }
    }
  } else {
    throw new Error('Invalid component type: ' + componentType)
  }
}
